type TrashProps = { color?: string }

const Trash = ({ color }: TrashProps) => (
  <svg
    aria-hidden="true"
    width="1em"
    height="1em"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 5.37891V14.0456C13 14.3992 12.8595 14.7383 12.6095 14.9884C12.3594 15.2384 12.0203 15.3789 11.6667 15.3789H4.33333C3.97971 15.3789 3.64057 15.2384 3.39052 14.9884C3.14048 14.7383 3 14.3992 3 14.0456V5.37891"
      stroke={color || 'currentColor'}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 3.37891H15"
      stroke={color || 'currentColor'}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66675 3.37858V0.711914H10.3334V3.37858"
      stroke={color || 'currentColor'}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 8.03516L6 12.0352"
      stroke={color || 'currentColor'}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.0352L6 8.03516"
      stroke={color || 'currentColor'}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Trash
